import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class ParentDepartment extends EntityDto implements IEntityDto {
  ParentDepartment_Id: string;
  ParentDepartmentName: string;
  ParentDepartmentCode: string;
  EmailId: string;
  Phone: string;
  Company_Id: string;
  CompanyName: string;
  Division_Id: string;
  DivisionName: string;
  Location_Id: string;
  LocationName: string;
  TotalCount: number;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;

  constructor() {
    super();
    this.ParentDepartment_Id = '00000000-0000-0000-0000-000000000000';
    this.ParentDepartmentName = '';
    this.ParentDepartmentCode = '';
    this.Company_Id = "";
    this.CompanyName = "";
    this.Division_Id = "";
    this.DivisionName = "";
    this.Location_Id = '';
    this.LocationName = '';
    this.EmailId = '';
    this.Phone = '';
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [
      { FieldName: 'ParentDepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Parent Department Name is required' },
      //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
      { FieldName: 'ParentDepartmentCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
      { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
      { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Head is required' },

    ];
  }
}